import type { ChatbotConfig } from 'app/shared/services/data-order.service';

export interface RoseRxWidgetConfig {
  src: string;
  widgetId: string;
}

const ROSE_RX_SCRIPT_SRC = 'https://app.roserx.ai/embed.js';

export function parseRoseRxWidgetConfig(chatbotConfig?: ChatbotConfig[]): RoseRxWidgetConfig | null {
  for (const config of chatbotConfig || []) {
    const widgetConfig = parseScript(config?.script);
    if (widgetConfig) {
      return widgetConfig;
    }
  }

  return null;
}

function parseScript(script?: string): RoseRxWidgetConfig | null {
  if (!script) {
    return null;
  }
  const normalizedScript = script
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, '\'');

  const src = getAttributeValue(normalizedScript, 'src');
  const widgetId = getAttributeValue(normalizedScript, 'data-widget');

  if (src !== ROSE_RX_SCRIPT_SRC || !widgetId) {
    return null;
  }

  return { src, widgetId };
}

function getAttributeValue(script: string, attributeName: string): string | null {
  const pattern = new RegExp(`${attributeName}=["']([^"']+)["']`);
  const value = script.match(pattern)?.[1]?.trim();
  return value || null;
}
